module.exports = __webpack_public_path__ + "static/media/code.11da0fe1.png";